export { namespace } from './actions';
import { Status, ActionType } from './actions';

const initialState = {
  orgs: {
    status: Status.INITIAL,
    data: []
  },
  orgGroups: {
    status: Status.INITIAL,
    data: []
  },
  accessibleOrgs: {
    status: Status.INITIAL,
    data: []
  },
  enableEngines: {
    status: Status.INITIAL,
    data: {}
  }
};

export default function orgManagementReducer(state = initialState, action) {
  const { LOADING, LOADED, ERROR, INITIAL } = Status;

  switch (action.type) {
    case ActionType.LOAD_ORGS:
      {
        const { orgs } = state;
        orgs.status = LOADING;
        return {
          ...state,
          orgs
        }
      }
    case ActionType.LOAD_ORGS_BY_IDS:
      {
        const { orgs } = state;
        if (orgs.status !== LOADED) { // if all orgs haven't been fetch yet
          orgs.status = LOADING;
        }
        return {
          ...state,
          orgs
        }
      }
    case ActionType.LOAD_ACCESSIBLE_ORGS:
      {
        const { accessibleOrgs } = state;
        accessibleOrgs.status = LOADING;

        return {
          ...state,
          accessibleOrgs
        }
      }
    case ActionType.LOAD_ORG_GROUPS:
    case ActionType.CREATE_ORG_GROUP:
    case ActionType.UPDATE_ORG_GROUP:
      {
        const { orgGroups } = state;
        orgGroups.status = LOADING;
        return {
          ...state,
          orgGroups
        }
      }
    case ActionType.SET_ORGS:
      {
        const { orgs } = action.payload;
        return {
          ...state,
          orgs: {
            status: LOADED,
            data: orgs
          }
        }
      }
    case ActionType.SET_ACCESSIBLE_ORGS:
    {
      const { orgs } = action.payload;
      return {
        ...state,
        accessibleOrgs: {
          status: LOADED,
          data: orgs
        }
      }
    }
    case ActionType.SET_PARTIAL_ORGS:
      {
        const { data } = state.orgs;
        const { orgs } = action.payload;
        return {
          ...state,
          orgs: {
            status: INITIAL,
            data: [...data, ...orgs]
          }
        }
      }
    case ActionType.SET_ORG_GROUPS:
      {
        const { orgGroups } = action.payload;
        return {
          ...state,
          orgGroups: {
            status: LOADED,
            data: [...orgGroups]
          }
        }
      }
    case ActionType.SET_LOAD_ORG_ERROR:
      {
        const newState = { ...state };
        newState.orgs.status = ERROR;
        return newState;
      }
    case ActionType.SET_LOAD_GROUPS_ERROR:
      {
        const newState = { ...state };
        newState.orgGroups.status = ERROR;
        return newState;
      }
    case ActionType.SET_LOAD_ACCESSIBLE_ORGS_ERROR:
    {
      const newState = { ...state };
      newState.accessibleOrgs.status = ERROR;
      return newState;
    }
    case ActionType.SET_ENABLE_ENGINES:
      {
        return {
          ...state,
          enableEngines: {
            status: 'loaded',
            data: {
              ...state.enableEngines.data,
              ...action.payload,
            }
          }
        }
      }
    default:
      return state;
  }
}
